import { join } from 'light-component';
import { Box } from '@common';
import styles from '../style.module.less';
import { service } from '../service';
import { Highlighter } from '../../component';
import { GridDesigner } from './grid-designer';
import type { ReactElement } from 'react';
import type { ShotEyesGridProps } from './types';

export function ShotEyesGridInputMode(props: ShotEyesGridProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={join(styles.subject)}>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
      </Box>
      <Box className={styles.input}>
        <GridDesigner {...props}
          type='input'
          className={styles.grid}
          onChange={event => props.onPropsChange?.({ value: event.value })}
        />
      </Box>
    </Box>
  );
}
